import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { useNavigate, useParams } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import { toast } from "react-toastify";
import { BiSolidCheckCircle, BiSolidXCircle } from "react-icons/bi";
import TestForPackage from "./testsByPackagePopup";
import { FiInfo } from "react-icons/fi";
import { FaDownload } from "react-icons/fa";
import "jspdf-autotable";
import FamilyAppointmentCancel from "./familyAppointmentCancelPopup";
import AppointmentReschedule from "./appointmentReschedule";
import { FaRedoAlt } from 'react-icons/fa';
import FamilyDisclaimerPopup from "./familyDisclaimerPopup";
import { Pagination } from "react-bootstrap";

function FamilyAppointments() {
    const {memberid} = useParams();
    const [appointmentDetails, setAppointmentDetails] = useState([]);
    const [loader, setLoader] = useState(true);
    const [isReschedulePopupOpen, setIsReschedulePopupOpen] = useState(false);
    const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
      const [currentPage, setCurrentPage] = useState(0);
      const [totalPages, setTotalPages] = useState(0);

    const navigate = useNavigate();

    const companycode = JSON.parse(localStorage.getItem("data")).orgcode;
  
  const getData = async (pageNumber = 0) => {
      const token = JSON.parse(localStorage.getItem("data")).token;
      setLoader(true);
      try {
        const trans = await axios.get(`/api/employeeappointment/getAllAppointmentsByFamilyid/familyid=${memberid}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(trans.data.content);
      // setFilteredData(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        handleError(error);
      }
    };

    const [isEmployee, setIsEmployee] = useState(false);
    const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);

    const handleShowDisclaimerModal = () => setShowDisclaimerModal(true);
    const handleCloseDisclaimerModal = () => setShowDisclaimerModal(false);
  
    useEffect(() => {
      getData();
      const userData = JSON.parse(localStorage.getItem("data"));
      if (userData && userData.role === "ROLE_EMPLOYEE") {
        setIsEmployee(true);
      }
    }, [memberid]);
  
   const handleBookAppointment = async () => {
      const token = JSON.parse(localStorage.getItem("data")).token;
      setLoader(true);
      
      try {
        // Fetch company details
        const companyResponse = await axios.get(`/api/companydetails/companycode=${companycode}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        const companyData = companyResponse.data;
        
        // Check if pilotOrganization is true
        if (companyData.pilotOrganization === true) {
          // Navigate to booking page
          navigate(`/users/bookAnAppointmentForFamilyMember/${memberid}`);
        } else {
          // Show disclaimer popup
          handleShowDisclaimerModal();
        }
        
        setLoader(false);
      } catch (error) {
        setLoader(false);
        handleError(error);
      }
    };
  
    const handleViewReport = (reportId) => {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const url = `/api/employee-appointment-reports/view/${reportId}`;
      axios({
        url,
        method: "GET",
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      }).then((response) => {
        const contentType = response.headers["content-type"] || "application/octet-stream";
        const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
        window.open(blobUrl, "_blank");
      }).catch(() => toast.error("Failed to view report."));
    };

    const handleDownloadReport = (reportId, fileName) => {
      const token = JSON.parse(localStorage.getItem("data")).token;
      axios({
        url: `/api/employee-appointment-reports/view/${reportId}`,
        method: "GET",
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      }).then((response) => {
        const contentType = response.headers["content-type"] || "application/octet-stream";
        const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", fileName || "report");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      }).catch(() => toast.error("Failed to download report."));
    };

     const handleDownloadReciept = (userid, paymentId) => {
    navigate('/users/payment-receipt', { 
      state: { userid: userid, paymentId:paymentId } 
    });
  };
  
    function handleError(error) {
      if (error.response) {
        if (error.response.status === 401) {
          navigate(`/signin`);
          toast.error("Your session has expired. Please login.");
        } else if (error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        }  else if (error.response.data && error.response.data.code) {
          toast.error(error.response.data.code);
        }
         else {
          toast.error("An error occurred.");
        }
      } else if (error.message) {
        toast.error(error.message);
      } else {
        toast.error("An error occurred.");
      }
    }
  
    const [loading, setLoading] = useState(null);
    
function rsubmit(e, id, status) {
    e.preventDefault();
    setLoading(id);
  
    const token = JSON.parse(localStorage.getItem("data")).token;
  
    const entitiesToUpdate = ({
      id: id,
      reportstatus: status,
    });
  
    axios
      .post(
        "/api/employeeappointment/approve",
        entitiesToUpdate,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        console.log(response.data);
        setLoading(null);
        getData();
      })
      .catch((error) => {
       handleError(error);
      });
  }

  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const openTestsModal = (pkg) => {
    setSelectedPackage(pkg);
      setIsTestsModalOpen(true);
  };

  const closeTestsModal = () => {
    setSelectedPackage(null);
    setIsTestsModalOpen(false);
  };

  const handleAcceptAppointment = async (appointmentId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoader(true);
    try {
      await axios.post(
        "/api/employeeappointment/accept-or-reschedule",
        {
          id: `${appointmentId}`,
          appointmentstatus: "APPOINTMENT CONFIRMED",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Employee Appointment Confirmed successfully.");
      getData();
      setLoader(false);
    } catch (error) {
    setLoader(false);
      handleError(error);
 
    }
  };

  const handleRescheduleAppointment = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsReschedulePopupOpen(true);
  };

  const handleCloseReschedulePopup = () => {
    setIsReschedulePopupOpen(false);
    getData();
  };

  const handleCancelClick = async (appointment) => {
    setSelectedAppointment(appointment)
    setIsCancelPopupOpen(true);
  };
  
  const handleCloseCancelPopup = () => {
    setIsCancelPopupOpen(false);
    getData();
  };
  const handleBack = () => {
    navigate(-1);
  };

  const handleRetry = async (appointment) => {
    setLoader(true); 
    const token = JSON.parse(localStorage.getItem('data')).token;

    try {
      await axios.post('/api/employeeappointment/re-trigger-api', appointment, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Retried successfully');
      getData();
    } catch (error) {
      toast.error('Retry failed');
    } finally {
      setLoader(false); 
    }
  };

  const handleFetchReport= async (appointment) => {
    setLoader(true); 
    const token = JSON.parse(localStorage.getItem('data')).token;

    try {
      await axios.post('/api/employeeappointment/fetchReport', appointment, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Report fetched successfully');
      getData();
    } catch (error) {
     handleError(error);
    } finally {
      setLoader(false); 
    }
  };


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
      getData(newPage);
    
  };  

    const renderPageNumbers = () => {
      const pageNumbers = [];
      const maxPageNumbersToShow = 5;
      let startPage = Math.max(0, currentPage - 2);
      let endPage = Math.min(totalPages - 1, currentPage + 2);
  
      if (currentPage <= 2) {
        endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
      }
  
      if (currentPage >= totalPages - 3) {
        startPage = Math.max(0, totalPages - maxPageNumbersToShow);
      }
  
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(
          <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
            {i + 1}
          </Pagination.Item>
        );
      }
      return pageNumbers;
    };
    
    return (
      <div>
       
        <div className="col-12 mx-xl-auto">
        <div className="mb-2">  
        <button className="btn btn-primary" onClick={handleBack}>
      Back
    </button>
        </div>
          <div className="card card-raised">
            <div className="card-body">
              <div className="card-title form-group d-flex align-items-center justify-content-between">
                <span>Appointment Details</span>
                {isEmployee && (
                     <button className="btn btn-primary" onClick={handleBookAppointment}>
                  Book Appointment
                </button>
                )}
              </div>
              <br />
              <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                    <th>Sl.No.</th>
                    <th>Date</th>
                    {/* <th>Time</th> */}
                    <th>Lab Name</th>
                    <th>Lab Contact Number</th>
                    <th>lab Test</th>
                    <th>Status</th>
                    <th>Report</th>
                    {JSON.parse(localStorage.getItem("data")).role==="ROLE_ADMIN" || JSON.parse(localStorage.getItem("data")).role==="ROLE_SUPER" && (
                    <th>Report Status</th>
                    )}
                     
                    <th>Reciept</th>
                    <th>Lab Order Status</th>

                  </tr>
                </thead>
                <tbody>
                  {appointmentDetails.length === 0 ? (
                    <tr>
                      <td colSpan="10" className="text-center">
                        No Data Available
                      </td>
                    </tr>
                  ) : (
                    appointmentDetails.map((appointment, index) => (
                      <tr key={appointment.id}>
                        <td>{index + 1}</td>
                        <td>{appointment.date}</td>
                        {/* <td>{appointment.time}</td> */}
                        <td>{appointment.labs?.labname}</td>
                        <td>{appointment.labs?.contact}</td>
            
                        <td>
                                   {appointment.pack!==null && (
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                                                                                  <span style={{
                                                                                    backgroundColor: '#405469ff',
                                                                                    color: 'white',
                                                                                    padding: '6px 12px',
                                                                                    borderRadius: '20px',
                                                                                    fontWeight: '500',
                                                                                    display: 'inline-block',
                                                                                    fontSize: '14px'
                                                                                  }}>{appointment.pack?.packagename}</span>
                                                                                  <FiInfo
                                                                                     onClick={() => openTestsModal(appointment.packageid)}
                                                                                    style={{
                                                                                      cursor: 'pointer',
                                                                                      fontSize: '24px',
                                                                                    }}
                                                                                  />
                                                                                 </div>
                                   )}
                                                                    
                                                           <div>
                                                              {appointment.additionalTest && appointment.additionalTest.length > 0 && (
                                                                <>
                                                            Additional Tests:
                                                             <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                                      {
                                                        appointment.additionalTest.map((test, i) => (
                                                          <li key={i}>{test.testDetails?.testname}</li>
                                                        ))
                                                  
                                                      }
                                                    </ul>
                                                    </>
                                                              )}
                                                           </div>
                                                                    </td>
                      <td>
  <div>{appointment.appStatus?.appointmentStatus }</div>
  {(appointment.appointmentstatus!=='APPOINTMENT CANCELLED'||appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED') && (appointment.appointmentstatus!=='APPOINTMENT COMPLETED'||appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED') && (
  // {appointment.appointmentstatus !== 'APPOINTMENT CANCELLED' && appointment.appointmentstatus !== 'APPOINTMENT COMPLETED' && (
  <>
    <div>
      {/* Show the Accept button if the appointment is rescheduled by Lab and not yet confirmed */}
      {appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CONFIRMED' && 
        appointment.appStatus?.appointmentStatus === 'APPOINTMENT RESCHEDULED' && 
        appointment.appStatus?.updatedBy !== 'Employee' && (
        <button
          className="btn btn-success btn-sm rounded-pill me-2"
          onClick={() => handleAcceptAppointment(appointment.id)}
        >
          Accept
        </button>
      )}
      
      {/* Cancel button, displayed only if the appointment is neither CANCELLED nor COMPLETED */}
      <button
        className="btn btn-danger btn-sm rounded-pill"
        onClick={() => handleCancelClick(appointment)}
      >
        Cancel
      </button>
    </div>
    
    <div className="mt-2">
      <button
        className="btn btn-warning btn-sm rounded-pill"
        onClick={() => handleRescheduleAppointment(appointment.id)}
      >
        Reschedule
      </button>
    </div>
  </>
)}

</td>
<td>
{appointment.appStatus?.appointmentStatus==='APPOINTMENT CANCELLED' ? (
'NA'
):appointment.orderStatus ? (
    appointment.orderStatus?.appointmentReport ? (
      appointment.reportstatus === 'APPROVED' ? (
        <div>
          {/* Display the appointment report as a link if approved */}
          <a
            href={appointment.orderStatus.appointmentReport}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Report
          </a>
        </div>
      ) : (
      "APPROVAL PENDING"
      )
    ) : (
      <button onClick={() => handleFetchReport(appointment)}>
        Fetch Report
      </button>
    )
  ) : (
    appointment.reportstatus ? (
      appointment.reportstatus === 'APPROVED' ? (
        <>
          {(appointment.reports || []).length > 0 ? (
            <ul className="list-unstyled mb-0">
              {(appointment.reports || []).map((report, ri) => (
                <li key={report.id} className="d-flex align-items-center justify-content-between mb-1" style={{gap:'6px'}}>
                  <span
                    style={{cursor:'pointer', color:'#0d6efd', textDecoration:'underline', fontSize:'13px', flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}
                    onClick={() => handleViewReport(report.id)}
                    title={report.fileName || `File ${ri + 1}`}
                  >
                    {report.fileName || `File ${ri + 1}`}
                  </span>
                  <FaDownload
                    size={14}
                    style={{cursor:'pointer', color:'#198754', flexShrink:0}}
                    title="Download"
                    onClick={() => handleDownloadReport(report.id, report.fileName)}
                  />
                </li>
              ))}
            </ul>
          ) : (
            <span className="text-muted" style={{fontSize:'12px'}}>No files</span>
          )}
        </>
      ) : (
        "APPROVAL PENDING"
      )
    ) : (
      "No Report Added"
    )
  )}

</td>
                        {JSON.parse(localStorage.getItem("data")).role==="ROLE_ADMIN" || JSON.parse(localStorage.getItem("data")).role==="ROLE_SUPER"&& (
                        <td>
                        {appointment.reportstatus ? (
                          <>
                            {appointment.reportstatus === "REQUESTED" ? (
                              <td id="icon" value={appointment.reportstatus}>
                                &nbsp;
                                {appointment.reportstatus} &nbsp;
                                {loading && (
                                  <div
                                    className="loader"
                                    style={{
                                      position: "relative",
                                      left: "75px",
                                      top: "10px",
                                    }}
                                  ></div>
                                )}{" "}
                                <BiSolidCheckCircle
                                  className="icon"
                                  id="appointment.reportstatus"
                                  style={{ backgroundColor: "green" }}
                                  value="APPROVED"
                                  onClick={(e) =>
                                    rsubmit(e, appointment.id, "APPROVED")
                                  }
                                />
                                &ensp;
                                <BiSolidXCircle
                                  className="icon"
                                  value="REJECTED"
                                  style={{ backgroundColor: "red" }}
                                  id="appointment.reportstatus"
                                  onClick={(e) =>
                                    rsubmit(e, appointment.id, "REJECTED")
                                  }
                                />
                              </td>
                            ) : (
                              <td id="icon" value={appointment.reportstatus}>
                                {" "}
                                {appointment.reportstatus}
                              </td>
                            )}
                          </>
                        ) : (
                          "No Report Added"
                        )}
                      </td>
                        )}
                       <td 
  style={{
    cursor: appointment.paymentId !== null ? "pointer" : "default",
    textAlign: "center", // Center alignment
    verticalAlign: "middle", // Vertically align content
  }} 
  title={appointment.paymentId !== null ? "Download Receipt" : ""}
  onClick={() => appointment.paymentId !== null && handleDownloadReciept(appointment.userid, appointment.paymentId)}
>
  {appointment.paymentId !== null ? <FaDownload /> : "NA"}
</td>

                        <td>
  <div>{appointment.orderStatus?.status}</div>

  <div>
    {appointment.orderStatus ? (
      <>
      <br/>
        {(appointment.orderStatus?.orderId === "" || appointment.orderStatus?.orderId == null) && (appointment.appointmentstatus!=='APPOINTMENT CANCELLED')  ? (  // Check for both empty string and null/undefined
          <>
            <button
              onClick={() => handleRetry(appointment)}
              style={{ cursor: 'pointer', color: 'red' }}
            >
              Retry
              <FaRedoAlt/>
            </button>
          </>
        ) : (
          <div>{appointment.orderStatus?.orderId}</div>
        )}
      </>
    ) : (
      <div>NA</div>
    )}
  </div>
</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              </div>
                  <div className="d-flex justify-content-center">
                            <Pagination>
                              <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                              <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                              {renderPageNumbers()}
                              <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                              <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
                            </Pagination>
                          </div>
            </div>

            {isTestsModalOpen && (
            <TestForPackage
                    isOpen={isTestsModalOpen}
                    onRequestClose={closeTestsModal}
                    packageId={selectedPackage}
                  />
            )}

{isCancelPopupOpen &&(
   <FamilyAppointmentCancel
   isOpen={isCancelPopupOpen}
   onRequestClose={handleCloseCancelPopup}
   appointment={selectedAppointment}
 />
)}
  {isReschedulePopupOpen && (
          <AppointmentReschedule
            isOpen={isReschedulePopupOpen}
            onRequestClose={handleCloseReschedulePopup}
            appointmentId={selectedAppointmentId}
          />
        )}

{showDisclaimerModal && (
           <FamilyDisclaimerPopup isOpen={showDisclaimerModal} onRequestClose={handleCloseDisclaimerModal}  memberid={memberid}/>
           )}
          </div>
          {loader && <div className="loading"></div>}
        </div>
      </div>
    );
  }
  

export default FamilyAppointments;